<template>
  <div :class="[baseCss, vertical ? `${baseCss}-vertical` : null]" role="tab">
    <div :class="[vertical ? ['bcq-table-layout', 'bcq-table-layout-collapse'] : null]">
      <div :class="[vertical ? 'bcq-table-layout-row' : null]">
        <div :class="[vertical ? 'bcq-table-layout-cell' : null]">
          <div :is="vertical ? 'div' : 'table-layout'" v-if="labels.length" equal-cells y-align="middle" x-align="center" :class="['select-none', setTextColor(), setBgColor(), `${baseCss}-buttons`]">
            <div :is="vertical ? 'div' : 'row'">
              <div v-ripple v-for="(label, index) in labels" role="button" @click="selectTab(index)" :style="{width: vertical ? verticalButtonsWidth : null}" :is="vertical ? 'div' : 'cell'" :title="tabButtonHint ? label : null" :class="['bcq-tab-button', vertical ? dense ? null : 'text-center' : null, 'outline-none', selected === index ? null : ['opacity-70'], disabled.includes(index) ? ['disabled', 'pointer-events-none'] : 'cursor-pointer', dense ? 'p-2' : 'p-3', 'relative']" :key="index">
                <icon :provider="iconProvider" :name="icons[index]" v-if="dense && icons[index]" :color="color" :class="['transition-opacity', 'duration-500']" />
                <div v-if="label" :class="[dense ? ['inline-block', 'align-middle'] : 'block', uppercase ? 'uppercase' : null, dense ? null : 'truncate', bold ? 'font-semibold' : null, 'text-sm', 'bcq-tab-button-label', 'transition-opacity', 'duration-500']" v-html="label" />
                <icon :provider="iconProvider" :name="icons[index]" v-if="!dense && icons[index]" :color="color" :class="['transition-opacity', 'duration-500']" />
                <div :class="['absolute', 'w-full', 'left-0', 'bottom-0']">
                  <line-ripple height="4px" :visible="selected === index" :ripple-bg-color="selectedMarkerColor" :ripple-bg-color-lightness="selectedMarkerColorLightness" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="[vertical ? ['bcq-table-layout-cell', 'bcq-table-layout-cell-v-align-top'] : null]">
          <carousel ref="carousel" :slide-duration="slideDuration" :easing="easing" :default-slide="defaultTab" :arrow-navigation="false" :aspect-ratio="null" dots="none" :buttons="false" :count="false">
            <slot />
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'Tab',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('tab', []),
      selected: 0,
      labels: [],
      disabled: [],
      icons: []
    }
  },
  props: {
    slideDuration: {
      type: Number,
      default: 300,
      validator: value => {
        return [
          75,
          100,
          150,
          200,
          300,
          500,
          700,
          1000
        ].includes(value)
      }
    },
    easing: {
      type: String,
      default: 'in',
      validator: value => {
        return [
          'in',
          'out',
          'in-out',
          'linear'
        ].includes(value)
      }
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    bold: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean
    },
    verticalButtonsWidth: {
      type: String
    },
    defaultTab: {
      type: Number,
      default: 0
    },
    tabButtonHint: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    dense: {
      type: Boolean
    },
    paddingOff: {
      type: Boolean
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'black'
    },
    selectedMarkerColorLightness: {
      type: [Number, String],
      default: null,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    selectedMarkerColor: {
      type: String,
      default: 'white'
    },
    height: {
      type: String,
      default: 'auto'
    }
  },
  watch: {
    vertical () {
      this.$nextTick(() => {
        this.setItemsHeight()
      })
    },
    dense () {
      this.$nextTick(() => {
        this.setItemsHeight()
      })
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    setItemsHeight () {
      const tabButtonsHeight = this.getTabButtons().offsetHeight
      this.getTabPanels().forEach(item => {
        item.style.height = !this.vertical ? this.height : this.height !== 'auto' ? `${tabButtonsHeight}px` : 'auto'
      })
    },
    getTabButtons () {
      return this.$el.querySelector('.bcq-tab-buttons')
    },
    getTabPanels () {
      return this.$el.querySelectorAll('.bcq-tab-panel')
    },
    selectTab (index = 0) {
      this.setItemsHeight()
      this.$refs['carousel'].scroll(index)
      this.selected = index
      this.$emit('change', {
        name: this.name,
        selectedTab: index
      })
    },
    onMounted () {
      this.getTabstripItems()
    },
    getTabstripItems () {
      const labels = []
      const disabled = []
      const icons = []
      this.$refs['carousel'].$children.forEach((item, index) => {
        const label = item.label
        const icon = item.icon
        if (label || icon) {
          labels.push(item.label)
          icons.push(item.icon || '')
          if (item.disabled) {
            disabled.push(index)
          }
        }
      })
      this.labels = labels
      this.disabled = disabled
      this.icons = icons
      this.selected = this.defaultTab
      this.$nextTick(() => {
        this.selectTab(this.selected)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/tab/tab.vue